import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'

import { getPlaylist } from '@disco/state-management/selectors/playlists'
import { makeGetShortlistTracks } from '@disco/state-management/selectors/shortlists'

import type { Playlist } from 'types/playlist'
import type { Track } from 'types/track'

import BulkEditor from 'components/bulk-editor'

function mapStateToProps(state, props) {
  // Handle both playlist and shortlist contexts
  const playlistId = props.params.playlistId || props.params.shortlistId
  const playlist = getPlaylist(state, { id: playlistId })

  // If this is a shortlist context (no playlist found), get tracks from shortlist
  if (!playlist && props.params.shortlistId) {
    const getShortlistTracks = makeGetShortlistTracks()
    const tracks = getShortlistTracks(state, props.params).filter(
      track => track && !track.outside_your_territories,
    )

    return {
      tracks: tracks,
    }
  }

  return {
    playlist: playlist,
  }
}

const connector = connect(mapStateToProps, {})

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  navigate: NavigateFunction
}

class ExplorerBulkEdit extends React.Component<Props> {
  _onClose = () => {
    this.props.navigate(-1)
  }

  render() {
    // Handle both playlist and tracks editing modes
    const editing = this.props.playlist
      ? { playlist: this.props.playlist }
      : { tracks: this.props.tracks || [] }

    return (
      <BulkEditor editing={editing as any} onRequestClose={this._onClose} />
    )
  }
}

const ConnectedExplorerBulkEdit = connector(ExplorerBulkEdit)

const ExplorerBulkEditWithNavigation = (props: any) => {
  const navigate = useNavigate()
  const params = useParams<{ playlistId: string }>()
  return (
    <ConnectedExplorerBulkEdit {...props} navigate={navigate} params={params} />
  )
}

export default ExplorerBulkEditWithNavigation
